// Pin / Unpin action builder.

import { Pin } from "lucide-react";

import type { MessageAction } from "~/components/MessageActions";

export function buildPinAction(params: {
  isPinned: boolean;
  onToggle: () => void;
  disabled?: boolean;
}): MessageAction {
  return {
    id: "pin",
    label: params.isPinned ? "Unpin" : "Pin",
    icon: Pin,
    onClick: params.onToggle,
    active: params.isPinned,
    disabled: params.disabled,
  };
}
